import { FormattedMessage } from "react-intl";

import InternalLink from "@components/typography/InternalLink";
import useMyClient from "@hooks/useMyClient";
import { journeyRoute } from "@utils/routeUtils";

type Props = {
  journeyId: string;
  translationId: string;
};

const ScheduleConsultLink = ({ journeyId, translationId }: Props) => {
  const myClient = useMyClient();

  return (
    <InternalLink to={journeyRoute({ journeyId, linkAfterJourney: "/schedule-consult", myClient })}>
      <FormattedMessage id={translationId} />
    </InternalLink>
  );
};

export default ScheduleConsultLink;
